// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"6":"page_student_app","194":"page_teacher_home_2","553":"page_teacher_app"}[chunkId] || chunkId) + ".860e566.chunk.js";
};